<template>

  <v-container fluid class="px-10 pb-8 route-vehicle-driver-summary" v-if="route">

    <v-row>
      <!-- Driver Info -->
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" align="left" class="mb-2" v-if="driver">
        <div class="title">Assigned Driver:</div>
        <div class="mt-5">
          <span class="detail-label pr-4">Name:</span>
          <span class="driver-name">{{ driverName }}</span>
        </div>
        <div class="mt-4">
          <span class="detail-label pr-4">DL#</span>
          {{ driver.drivers_license_number }}
        </div>
        <div class="mt-2">
          <span class="detail-label pr-4">FA#</span>
          {{ driver.fa_license_number }}
        </div>
      </v-col>

      <!-- Vehicle Info -->
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" align="left" v-if="vehicle">
        <div class="title">Assigned Vehicle:</div>
        <div class="mt-5 vehicle-label">
          {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.vehicle_model }}
        </div>
        <div class="mt-4">
          <span class="detail-label pr-4">Color:</span>
          {{ vehicle.color }}
        </div>
        <div class="mt-2">
          <span class="detail-label pr-4">Plate:</span>
          {{ vehicle.license_plate }}
        </div>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>

export default {
  name: 'RouteVehicleDriverSummary',

  props: {
    route: {
      type: Object
    }
  },

  computed: {
    // -------------------- Assigned driver
    driver () {
      return (this.route) ? this.route.driver : null
    },
    driverName () {
      if (this.driver) {
        const firstName = this.driver.first_name
        const lastName = this.driver.last_name
        return (lastName) ? `${firstName} ${lastName}` : firstName
      } else {
        return null
      }
    },
    // -------------------- Assigned vehicle
    vehicle () {
      return (this.route) ? this.route.vehicle : null
    }
  }

}
</script>

<style scoped>
  .route-vehicle-driver-summary .detail-label {
    color: #9e9e9e;
  }

  .route-vehicle-driver-summary .driver-name {
    font-size: 1.2rem;
  }

  .route-vehicle-driver-summary .vehicle-label {
    font-size: 1.2rem;
  }
</style>
